import classNames from "classnames";

import AscFilesUploader from "../../AscFilesUploader/AscFilesUploader";
import AscTextInput from "../../AscInputFields/AscTextInput/AscTextInput";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import { TrashIcon } from "../../AscIcons";

import styles from "./AscAddActivityQuestionAnswerCard.module.scss";
import { If } from "react-conditional-components-renderer";
import { ActivityImage } from "@ascendnow/shared";

export interface AscAddActivityQuestionAnswerCardProps {
  className?: string;
  value: Partial<Record<"question" | "answer", string>>;
  image?: ActivityImage;
  onChange: (value: Partial<Record<"question" | "answer", string>>) => void;
  onImageUpload?: (value: ActivityImage) => void;
  onImageRemove?: (value: ActivityImage) => void;
  onDelete?: () => void;
  canDelete?: boolean;
  type?: "flashcards" | "quizDragDrop";
}

export default function AscAddActivityQuestionAnswerCard({
  className,
  value,
  image,
  onChange,
  onImageUpload,
  onImageRemove,
  onDelete,
  canDelete = false,
  type = "flashcards",
}: AscAddActivityQuestionAnswerCardProps) {
  return (
    <div
      data-testid="asc-add-flash-card"
      className={classNames(styles.ground, className)}
    >
      <TrashIcon
        className={classNames(styles.trashIcon)}
        onClick={canDelete ? onDelete : undefined}
      />
      <AscParagraph className={styles.title}>Thumbnail</AscParagraph>

      <AscFilesUploader
        name="flashcards.image"
        accept={{
          "image/*": [".jpeg", ".png"],
        }}
        multiple={false}
        onDrop={(files) => onImageUpload?.(files?.[0])}
        onRemoveFile={() => image && onImageRemove?.(image)}
        initialValue={image ? [image] : undefined}
        srcFile={
          image
            ? image?.__activityImage?.location || URL.createObjectURL(image)
            : undefined
        }
      />

      <div className={styles.form}>
        <If test={type === "flashcards"}>
          <div className={styles.fieldForm}>
            <label className={styles.fieldLabel} htmlFor="question">
              Question
            </label>
            <AscTextInput
              fullWidth={true}
              id="question"
              placeholder="Question"
              onChange={(e) => onChange?.({ question: e?.target?.value })}
              value={value?.question}
            />
          </div>
        </If>

        <div className={styles.fieldForm}>
          <label className={styles.fieldLabel} htmlFor="answer">
            Answer
          </label>
          <AscTextInput
            id="answer"
            fullWidth={true}
            placeholder="Answer"
            onChange={(e) => onChange?.({ answer: e?.target?.value })}
            value={value?.answer}
          />
        </div>
      </div>
    </div>
  );
}
